<div class="column-controls no-print">
    <mat-form-field appearance="outline" class="column-selector" subscriptSizing="dynamic">
        <mat-label>Choose Columns</mat-label>
        <mat-select multiple [(ngModel)]="selectedColumns" [compareWith]="compareColumns" (selectionChange)="onColumnSelectionChange()" (openedChange)="onColumnSelectionOpenedChange($event)" data-testid="lp-detail-print-columns-select">
            <mat-select-trigger>
                {{ selectedColumns.length || 0 }} columns selected
            </mat-select-trigger>
            <div class="column-search-panel" (click)="onColumnSearchInteraction($event)">
                <mat-form-field appearance="outline" class="column-search-field" subscriptSizing="dynamic">
                    <mat-label>Search Columns</mat-label>
                        <input #columnSearchInput matInput [(ngModel)]="columnSearchTerm" placeholder="Type to filter columns" data-testid="lp-detail-print-columns-search-input" (keydown)="onColumnSearchKeydown($event)" (click)="onColumnSearchInteraction($event)">
                </mat-form-field>
                    <div class="column-search-actions">
                        <mat-checkbox class="column-toggle-all" [checked]="areAllFilteredColumnsSelected" [indeterminate]="areSomeFilteredColumnsSelected" [disabled]="!filteredColumnVisibilityOptions.length" data-testid="lp-detail-print-columns-toggleall-checkbox" (change)="toggleFilteredColumns($event.checked)" (click)="onColumnSearchInteraction($event)" (keydown)="onColumnSearchKeydown($event)">
                            Select all
                        </mat-checkbox>
                        <button mat-button type="button" class="column-clear-text-button" [disabled]="!columnSearchTerm" data-testid="lp-detail-print-columns-cleartext-button" (click)="clearColumnSearch($event)" (keydown)="onColumnSearchKeydown($event)">
                            Clear text
                        </button>
                    </div>
            </div>
            <mat-option *ngFor="let option of filteredColumnVisibilityOptions" [value]="option">
                {{ option.dropdownHeader }}
            </mat-option>
            <mat-option *ngIf="!filteredColumnVisibilityOptions.length" disabled>
                No matching columns
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>

<table data-testid="lp-detail-print-table">
    <thead>
        <tr text-align:left>
            <ng-container *ngFor="let selectedColumn of selectedColumns;let i=index;">
                <td [ngClass]="{'large':selectedColumn.dropdownHeader === 'Barcode [string]','small':selectedColumn.dropdownHeader==='Barcode [graphic]'}">
                    <div>
                        <button class="no-print" mat-icon-button *ngIf="i!=0" (click)="moveColumnLeft(i)" data-testid="lp-detail-print-moveleft-button"><mat-icon>arrow_back</mat-icon></button>
                        <span>{{selectedColumn.header}}</span>
                        <button class="no-print" mat-icon-button *ngIf="i!=selectedColumns.length-1"  (click)="moveColumnRight(i)" data-testid="lp-detail-print-moveright-button"><mat-icon>arrow_forward</mat-icon></button>
                    </div>
                </td>
            </ng-container>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let detail of detailsToPrint" text-align: left>
            <ng-container *ngFor="let col of selectedColumns">
                <td *ngIf="col.dropdownHeader ==='Sample'">
                    {{detail.sampleLabel}} - {{detail.sampleName}}
                </td>
                <td *ngIf="col.dropdownHeader ==='Condition'">
                    {{detail.conditionLabel}} - {{detail.conditionName}}
                </td>
                <td *ngIf="col.dropdownHeader ==='Replicate #'">
                    {{detail.replicateNo}}
                </td>

                <td *ngIf="col.dropdownHeader ==='Barcode [string]'" text-align: left class="large">
                    {{detail.readableBarcode}}  
                </td>
                <td *ngIf="col.dropdownHeader ==='Barcode [graphic]'" class="small">
                    <app-barcode-print 
                        [barcodeData]="detail.readableBarcode" 
                        (onLoaded)="onBarcodeLoaded($event)"
                        [templateType]="BarcodesTemplates.DISPLAY"
                        ></app-barcode-print>
                </td>
            </ng-container>
        </tr>
    </tbody>
</table>